import React from 'react';
import { Box, Spinner } from 'wt-ui';

const LoadingLayer = () => (
  <div style={{ position: 'absolute', width: '100%', height: '100%' }}>
    <Box fill align="center" justify="center" background="#5b677066">
      <Spinner primary />
    </Box>
  </div>
);

export default LoadingLayer;
